import React from 'react';
import { Form } from 'react-bootstrap';
import { isTempSavedValue } from './utils';
import { TempSavedValue } from '../types';

/**
 * RestoreFormコンポーネント用のPropsです。
 * @interface ResetButtonProps
 */
interface RestoreFormProps {
  /**
   * ボタンクリック時の動作を設定する関数
   * @memberof ResetButtonProps
   */
  onChange: (jsonObject: TempSavedValue) => void;
}

/**
 * 復元ボタンコンポーネントです。
 * @param {function} props.onClick - ボタンクリック時に呼ばれるコールバック関数
 * @returns {JSX.Element} - 復元ボタンのJSX要素
 */
const RestoreForm: React.FC<RestoreFormProps> = ({ onChange }) => {

  const handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    const confirm: boolean = window.confirm('一次保存データを取り込みますか？');
    if(file !== null && confirm === true) {
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const uploadedFileContents = JSON.parse(event.target?.result as string);
          if(isTempSavedValue(uploadedFileContents)) {
            onChange(uploadedFileContents);
          } else {
            window.alert('アップロードされたファイルの形式が誤っています。');
          }
        } catch(e) {
          window.alert('アップロードされたファイルの形式が誤っています。');
          return false
        }
      };
      reader.readAsText(file);
    }
    event.target.value = '';
  };

  return (
    <Form.Group
      controlId="formFile"
      onChange={handleFileInputChange}
    >
      <Form.Control type="file" accept=".json" />
    </Form.Group>
  );
};

export default RestoreForm;
